import { render, staticRenderFns } from "./WaiBuGongShi4.vue?vue&type=template&id=0e065778&scoped=true&"
import script from "./WaiBuGongShi4.vue?vue&type=script&lang=js&"
export * from "./WaiBuGongShi4.vue?vue&type=script&lang=js&"
import style0 from "./WaiBuGongShi4.vue?vue&type=style&index=0&id=0e065778&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e065778",
  null
  
)

export default component.exports